import Vue from 'vue'

Vue.prototype.$metaArray = function() {
  return []
}
